import type { CartItem } from "@/utils/cartUtils";

/**
 * Formats course or program name with brand prefix if available
 */
export const formatCourseName = (
  courseName: string,
  brand?: string | null,
): string => {
  if (brand && brand !== "Unknown Brand") {
    return `${brand}: ${courseName}`;
  }
  return courseName;
};

/**
 * Determines if cart items represent a program bundle
 * @deprecated We no longer have program specific carts
 */
export const isProgram = (items: CartItem[]): boolean => {
  const firstItem = items[0];
  return Boolean(
    firstItem?.bundleId &&
      items.every((item) => item.bundleId === firstItem.bundleId),
  );
};
